import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

import { formatDate } from 'helpers/dateUtils';
import Link from 'ui/Link';
import CodeBlock from 'ui/CodeBlock';

import 'css/ui/Post.css';




// Helper component for rendering images.
const PostImage = ({ src, alt, title }) => {
	return (
		<figure>
			<img src={src} alt={alt} />
			{title && <figcaption>{title}</figcaption>}
		</figure>
	);
};


// Define custom component overrides for specific elements.
const postElementRenderers = {
	link: Link,
	image: PostImage,
	code: CodeBlock
};


class Post extends React.Component {

	componentDidMount() {
		// Ensure that any embedded codepens are initialized by rerunning the `__CPEmbed` function.
		// "Normal" sites don't have to do this, because the embed markup isn't added dynamically with JS like we're doing.
		// Note: I couldn't find documentation on `__CPEmbed`, I found it myself. If embeds ever break, this is a likely culprit.
		// Also note that we only call the function if it exists. If it does not exist, it means the library probably hasn't
		// loaded yet. In that case, we don't have to do anything - the CodePen embed library will handle embeds on load.
		window.__CPEmbed && window.__CPEmbed();
	}

	render() {
		const { post } = this.props;

		return (
			<div className="post fade-slide-up">
				<h2 className="post__header">{post.title}</h2>
				<div className="post__meta">
					<time dateTime={post.date}>{formatDate(post.date)}</time>
				</div>

				<ReactMarkdown
					source={post.contentMarkdown}
					className="post__body post-content"
					renderers={postElementRenderers}
				/>
			</div>
		);
	}
}

export default Post;


Post.propTypes = {
	post: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/ui/Post.jsx